import type { LoginResult } from "@/types/auth";

/** 开发假登录固定 Token（联调后端，登录页任意有效邮箱+密码即可写入） */
export const MOCK_AUTH_TOKEN =
  "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIyMyIsInN5c3RlbVBvaW50IjoiYm9zcyIsImlhdCI6MTc4MTQ4NzE5NSwiZXhwIjoxNzgxNTczNTk1fQ.Vhd3RxHBETKR3ArHgAh2deT_4OScOoz8Y73z2P-p_Y6-On_JcgKSzby8LjXqAnzyG1E4PQY8kPQMHCCHWk-biA";

/**
 * 生成假登录响应：写入固定 JWT，后续请求走真实后端鉴权
 * @param email 登录邮箱（仅用于展示 username）
 */
export const getMockLoginResult = (email: string): LoginResult => ({
  accessToken: MOCK_AUTH_TOKEN,
  user: {
    id: "23",
    username: email,
    nickname: "Boss 管理员",
  },
  permissions: [],
});

/** 是否为假登录 Token（跳过 /auth/me，其余接口仍带 Token 请求后端） */
export const isMockAuthToken = (token: string | null): boolean => token === MOCK_AUTH_TOKEN;
